import { FormlyFieldConfig } from '@ngx-formly/core';
import { environment as env } from "environments/environment";

export const DelegatoStep: FormlyFieldConfig[] = [
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 xl:grid-cols-3 grid-rows-1 gap-4',
        fieldGroup: [
            {
                className: 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                key: 'delegato.cognome',
                type: 'mat-input',
                props: {
                    label: 'COGNOME',
                    required: true,
                    uppercase: true,
                }
            },
            {
                className: 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                key: 'delegato.nome',
                type: 'mat-input',
                props: {
                    label: 'NOME',
                    required: true,
                    uppercase:true
                }
            },
            {
                className: 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                key: 'delegato.cf',
                type: '#cf',
                props:{
                    required:true
                }
            },
        ],
    },
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 xl:grid-cols-3 grid-rows-1 gap-4',
        fieldGroup: [
            {
                className: 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                key: 'delegato.sesso',
                type: 'mat-select',
                props: {
                    label: 'SESSO',
                    options: [
                        { value: 'M', label: 'M' },
                        { value: 'F', label: 'F' },
                    ],
                    required: true,
                }
            },
            {
                className: 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                key: 'delegato.comune_nato_dict',
                type: '#autocomplete-comune',
                props: {
                    label: 'COMUNE/STATO DI NASCITA',
                    required: true,
                },
            },
            {
                className: 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                key: 'delegato.data_nato',
                "type":"#data",
                "props": {
                  "label": 'DATA NASCITA',
                  "required": true,
                  "datepickerOptions": {
                    "startAt": new Date('1990-01-01')
                  }
                }
              },
        ],
    },
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-6 grid-rows-1 gap-4 sm:mt-5',
        fieldGroup: [
            {
                className: 'sm:col-span-1 md:col-span-3',
                key: 'delegato.email',
                type: '#email',
                props:{
                    required:true
                }
            },
            {
                className: 'sm:col-span-1 md:col-span-3',
                key: 'delegato.pec',
                type:'#email',
                props: {
                    label: 'PEC',
                },
                expressions: {
                    "props.required": ()=>env.comune=='RAPALLO',
                }
            },
            {
                className: 'sm:col-span-1 md:col-span-3',
                key: 'delegato.cellulare',
                type: 'mat-input',
                props: {
                    label: 'CELLULARE',
                }
            },
            {
                className: 'sm:col-span-1 md:col-span-3',
                key: 'delegato.telefono',
                type: 'mat-input',
                props: {
                    label: 'TELEFONO',
                    required: true,
                }
            },
        ],
    },
    {
        key: 'delegato.qualita',
        type: 'mat-select',
        props: {
            label: 'IN QUALITÀ DI',
            required: true,
            options: [
                { value: 'DELEGATO', label: 'DELEGATO' },
                {
                    value: 'LEGALE RAPPRESENTANTE',
                    label: 'LEGALE RAPPRESENTANTE',
                },
                {
                    value: 'PROFESSIONISTA INCARICATO',
                    label: 'PROFESSIONISTA INCARICATO',
                },
                { value: 'LIQUIDATORE', label: 'LIQUIDATORE' },
                { value: 'NOTAIO', label: 'NOTAIO' },
                { value: 'AMMINISTRATORE', label: 'AMMINISTRATORE' },
                { value: 'STUDIO ASSOCIATO', label: 'STUDIO ASSOCIATO' },
                { value: 'SOCIO', label: 'SOCIO' },
                { value: 'CONSULENTE', label: 'CONSULENTE' },
                { value: 'ALTRO', label: 'ALTRO' },
            ],
        }
    },
    {
        key: 'delegato.qualita_altro',
        type: 'mat-input',
        props: {
            label: 'SPECIFICA',
            required: true
        },
        expressions: {
            hide: "!(model.delegato?.qualita == 'ALTRO')",
        },

    },
    {
        fieldGroup: [
            {
                key: 'jd.intestatario_istanza_opt',
                type: 'mat-select',
                defaultValue: 'NO',
                props: {
                    label: 'HAI GIÀ PRESENTATO ISTANZE PER CONTO DI QUESTO INTESTATARIO?',
                    options: [
                        { value: 'SI', label: 'SI' },
                        { value: 'NO', label: 'NO' },
                    ],
                    color: 'primary',
                }
            },
            {
                "key": 'jd.intestatario_istanza',
                "type":'mat-autocomplete',
                "props": {
                    "label": "PUOI CARICARE I DATI DELL'INTESTATARIO DA UNA ISTANZA PRESENTATA IN PRECEDENZA",
                    "required": true,
                },
                "validation": {
                    "show": true,
                },
                validators:{
                    validation:['AutocompleteMatch'],
                }     ,
                "expressions": {
                    "props.filter": "formState.filterDelega",
                    "hide": "model.jd.intestatario_istanza_opt!='SI'",

                }
            }
        ],
        "expressions": {
            "hide": "model.tipo_id=='integrazione'"
        }
    }
];
